import { noop } from 'lodash';
import React, { FC, createContext, useMemo } from 'react';

import { AppLayoutBreakpoint, useContainerWidth } from '../../util/responsiveness';
import useOpenCloseState from '../../util/useOpenCloseState';

import { AppLayoutContextProviderProps, AppLayoutContextValue } from './AppLayoutContextProvider.types';

export const defaultOptions: AppLayoutContextValue = {
  isSidebarPanelOpen: false,
  openSidebarPanel: noop,
  closeSidebarPanel: noop,
  enableStickySidebar: false,
  openContentSidebarAriaLabel: '',
  closeContentSidebarAriaLabel: '',
  hasBackButton: false,
  gutterSize: 6,
  width: Infinity,
};

export const AppLayoutContext = createContext<AppLayoutContextValue | undefined>(undefined);

const AppLayoutContextProvider: FC<AppLayoutContextProviderProps> = ({
  closeContentSidebarAriaLabel,
  openContentSidebarAriaLabel,
  hasBackButton = false,
  enableStickySidebar = false,
  children,
}) => {
  const width = useContainerWidth();

  const { open: openSidebarPanel, close: closeSidebarPanel, isOpen: isSidebarPanelOpen } = useOpenCloseState();

  const gutterSize = width < AppLayoutBreakpoint.Width568 ? 3 : 6;

  const value: AppLayoutContextValue = useMemo(
    () => ({
      openSidebarPanel,
      closeSidebarPanel,
      isSidebarPanelOpen,
      enableStickySidebar,
      openContentSidebarAriaLabel,
      closeContentSidebarAriaLabel,
      hasBackButton,
      gutterSize,
      width,
    }),
    [
      openSidebarPanel,
      closeSidebarPanel,
      isSidebarPanelOpen,
      enableStickySidebar,
      openContentSidebarAriaLabel,
      closeContentSidebarAriaLabel,
      hasBackButton,
      gutterSize,
      width,
    ]
  );

  return <AppLayoutContext.Provider value={value}>{children}</AppLayoutContext.Provider>;
};

export default AppLayoutContextProvider;
